<template>
  <div class="messagePush">
    <div class="search">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="" prop="messageTitle">
          <el-input
            v-model="tableParams.messageTitle"
            placeholder="请输入关键字"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="resetForm(formRef)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button type="primary" size="small" @click="releaseNews(1)"
        >发布消息</el-button
      >
    </div>
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="notifymessageMymessage"
      :params="tableParams"
      @handleClick="handleClick"
      @select="hzTableSelect"
      style="height: 93%"
    >
      <template #operation="{row}">
        <!-- <el-button type="primary" size="small">撤回</el-button> -->
        <el-button type="primary" size="small" @click="releaseNews(2, row)"
          >重新发送</el-button
        >
      </template>
      <template #status="{row}">
        {{ row.status === "1" ? "已发送" : "未发送" }}
      </template>
      <template #createTime="{row}">
        {{ formatDateHMS(row.createTime) }}
      </template>
      <template #sendTime="{row}">
        {{ formatDateHMS(row.sendTime) }}
      </template>

      <template #messageText="{row}">
        <span v-html="row.messageText"></span>
      </template>
    </h-table>
  </div>
  <el-dialog v-model="Visible" title="消息发布" width="43%" height="40%">
    <formdialog
      :stateData="stateData"
      :Visible="Visible"
      :itemRow="itemRow"
      @submit="(Visible = false), onSubmit()"
    ></formdialog>
  </el-dialog>
</template>

<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import formdialog from "./formdialog";
import { notifymessageMymessage } from "@/api/messageCenter/messageCenterApi.js";
import { formatDateHMS } from "@/utils/index.js";
export default defineComponent({
  name: "messagePush",
  components: { formdialog },
  setup() {
    const state = reactive({
      Visible: false,
      stateData: 1,
      tableParams: { messageTitle: "" },
      columns: [
        { type: "selection" },
        {
          label: "id",
          prop: "countNum"
        },
        {
          label: "标题",
          prop: "messageTitle"
        },
        {
          label: "内容",
          slot: "messageText"
        },
        {
          label: "添加时间",
          slot: "createTime"
        },
        {
          label: "发送时间",
          slot: "sendTime"
        },
        {
          label: "目标人群",
          prop: "roleName"
        },
        {
          label: "发送状态",
          slot: "status"
        },
        {
          label: "操作",
          slot: "operation"
        }
        // {
        //   label: "阅读人数",
        //   slot: "cardNumber"
        // }
      ],
      itemRow: {}
    });
    const formRef = ref(null);
    const tableRef = ref(null);

    const methods = {
      hzTableSelect() {},
      releaseNews(is, row) {
        state.stateData = is;
        state.Visible = true;
        if (is === 2) {
          state.itemRow = row;
        } else {
          state.itemRow = {
            messagePointType: "1",
            messageTitle: "",
            messageText: "",
            sendTime: "",
            messagePointId: []
          };
        }
      },
      onSubmit() {
        tableRef.value && tableRef.value.refresh();
      },
      resetForm(formEl) {
        if (!formEl) return;
        formEl.resetFields();
      }
    };
    return {
      ...toRefs(state),
      ...methods,
      notifymessageMymessage,
      formRef,
      tableRef,
      formatDateHMS
    };
  }
});
</script>

<style lang="scss" scoped>
.messagePush {
  height: 100%;
  padding: 20px;
  .search {
    margin-left: 5px;
  }
}
</style>
